export const CHART = 'chart';
export const EQUIPMENTS_PATH = 'equipments';
export const MODEL_PROCESS_PATH = 'model-process';
export const SYSTEM_DETAILS_PATH = 'system-details';
